import { ImgUserPlaceholder } from '@/assets/images';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getInitialsFromName } from '../utils/userHelpers';
import ProfileImage from './ProfileImage';

export const UserProfile = ({ userId, name, image: propImage, className = '', defaultIcon = null, ...rest }) => {
   const user = useSelector(state => state.userInfoData?.users[userId]);
   const { nickName, image, isBlockedMe,isDeleted } = user || {};

   const finalName = nickName || name;
   const finalImage = propImage || image;
   const imageUri = isBlockedMe||isDeleted ? null : finalImage;

   const initials = getInitialsFromName(finalName);
   const showInitials = !isBlockedMe &&!isDeleted && !!initials && !defaultIcon;

   const renderPlaceholder = () => {
      if (isBlockedMe||isDeleted) return <ImgUserPlaceholder style={{ backgroundColor: 'transparent' }} />;
      if (defaultIcon) return defaultIcon;
      if (initials) {
         return <span className="chat-avatar-text">{initials}</span>;
      }
      return <ImgUserPlaceholder style={{ backgroundColor: 'transparent' }} />;
   };

   const containerClass = `${className} ${showInitials ? '' : 'no-initials'}`.trim();
   const containerStyle = !showInitials ? { backgroundColor: 'transparent' } : {};

   if (imageUri) {
      return (
         <ProfileImage
            className={containerClass}
            imageUri={imageUri}
            userId={userId}
            defaultImg={renderPlaceholder()}
            alt={finalName}
            style={containerStyle}
            {...rest}
         />
      );
   }

   return (
      <div className={containerClass} style={containerStyle}>
         {renderPlaceholder()}
      </div>
   );
};

UserProfile.propTypes = {
   userId: PropTypes.string,
   name: PropTypes.string,
   image: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Blob)]),
   className: PropTypes.string,
   defaultIcon: PropTypes.node,
};
